import styled, { css } from "styled-components";
import { colors, devices } from "../../../base/styled/variables.styled";
import { ModalPanel, Overlay, ContentInner, BodyModal, ContentModal } from "../../molecules/Modal/Modal.style";
const LinkStyles = css `
	.ps-header-inferior-menu-links {
		color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.neutral800};
		height: 100%;
		width: 100%;
		font-family: 'Figtree', sans-serif;
		font-weight: 400;
		line-height: 24px;
		text-decoration: none;
		white-space: nowrap;
		overflow: hidden;
		text-overflow: ellipsis;
		position: relative;
		border-radius: 8px;
		gap: 8px;
		-webkit-box-shadow: none;

		@media ${devices.desktop} {
			display: flex;
			align-items: center;
			justify-content: center;
			font-size: 14px;
			padding: 8px 12px;
			box-sizing: border-box;
			z-index: 99;
			font-weight: 400;
		}

		@media ${devices.tablets},
		${devices.mobile} {
			display: flex;
			align-items: center;
			font-size: 16px;
			height: 62px;
			padding: 0 16px;
			box-sizing: border-box;
			width: 100%;
			color: ${colors.neutral800}; // Mobile menu usually has white background, so keep dark text?
		}

		&:focus,
		&:hover {
			background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
		}

		@media ${devices.tablets}, ${devices.mobile} {
			&:focus,
			&:hover {
				background-color: ${colors.brand75};
			}
		}

		@media ${devices.desktop} {
			&:focus::before {
				position: absolute;
				inset: 0;
				content: "";
				//border: 3px solid ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand300};
				border-radius: 8px;
			}
		}

		@media ${devices.desktop} {
			&.active {
				color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
				background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};
			}

			&:active {
				color: ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand500};
				background-color: ${({ $inverse }) => $inverse ? colors.brand800 : colors.brand75};

				&::before {
					position: absolute;
					inset: 0;
					content: "";
					//border: 3px solid ${({ $inverse }) => $inverse ? colors.neutral000 : colors.brand300};
					border-radius: 8px;
				}
			}
		}
	}
`;
export const MenuWrapper = styled.nav.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
	display: flex;
	flex-direction: column;
	justify-content: center;
	// border-bottom: 1px solid ${colors.brand75};
  background-color: ${({ $inverse }) => $inverse ? "transparent" : "#fff"};
  padding: 0 48px;
	
	@media ${devices.tablets}, ${devices.mobile} {
		padding: 0;
	}	
	
	margin: 0px auto;
	
	width: 100%;
	font-family: "Figtree", sans-serif;
	position: relative;
	z-index: 100;

	${LinkStyles}

	${({ $inverse }) => $inverse && css `
		.ps-header-inferior-menu-links {
			color: ${colors.neutral000};

			&:focus,
			&:hover {
				background-color: rgba(255, 255, 255, 0.1);
			}

			@media ${devices.desktop} {
				&.active,
				&:active {
					color: ${colors.neutral000};
					background-color: rgba(255, 255, 255, 0.1);
				}
			}
		}
	`}

	@media ${devices.tablets}, ${devices.mobile} {
		border-bottom: 0;
	}
`;
export const DesktopMenuContainer = styled.div `
  max-width: 1280px;
  margin: 0px auto;

	@media ${devices.tablets}, ${devices.mobile} {
		display: none;
	}
`;
export const MenuList = styled.ul `
	gap: 8px;
	padding: 0;
	margin: 0;
	width: 100%;
	border-radius: 8px;
	list-style: none;
	@media ${devices.desktop} {
		display: flex;
		align-items: center;
		flex-direction: row;
		padding: 8px 0;
	}
	@media ${devices.tablets}, ${devices.mobile} {
		box-sizing: border-box;
		width: 100%;
		display: flex;
		flex-direction: column;
		padding: 0 0 16px 0;
	}
`;
export const MenuItemWrapper = styled.li `
	display: flex;
	align-items: center;
	height: 40px;
	flex-direction: column;
	border-radius: 8px;
	@media ${devices.tablets}, ${devices.mobile} {
		padding: 0;
		border-radius: 0;
		align-items: flex-start;
		justify-content: center;
	}
`;
export const HamburgerWrapper = styled.div `
	display: none;
	@media ${devices.tablets}, ${devices.mobile} {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		padding: 16px 8px;

		& > button {
			font-size: 24px !important;
		}
	}
`;
export const MobileMenuContainer = styled.div.withConfig({
    shouldForwardProp: (prop) => !['inverse', '$inverse'].includes(prop),
}) `
	display: none;
	
	@media ${devices.tablets}, ${devices.mobile} {
		display: block;
		width: 100%;
		box-sizing: border-box;

		${LinkStyles}

		${Overlay} {
			top: 104px !important;
			height: calc(100vh - 104px) !important;
			align-items: flex-end;
			justify-content: center;
			background-color: transparent !important;
			backdrop-filter: none !important;
			-webkit-backdrop-filter: none !important;
			position: fixed !important;
			overflow: hidden !important;
		}

		${ContentInner} {
			padding: 24px 24px 8px 24px !important;
		}

		${ModalPanel} {
			width: 100% !important;
			max-width: 100% !important;
			height: 100% !important;
			max-height: 100% !important;
			transform: translate3d(0, 100%, 0) !important;
			-webkit-transform: translate3d(0, 100%, 0) !important;
			border-radius: 16px 16px 0 0 !important;
			transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
			-webkit-transition: -webkit-transform 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;
			
			&[data-open="true"] {
				transform: translate3d(0, 0, 0) !important;
				-webkit-transform: translate3d(0, 0, 0) !important;
			}
		}

		${BodyModal} {
			height: 100% !important;
			min-height: 0 !important;
			max-height: 100% !important;
			display: flex !important;
			flex-direction: column !important;
            overflow: hidden !important;
		}

		${ContentModal} {
			flex: 1 1 auto !important;
			overflow-y: auto !important;
			height: 100% !important;
			max-height: 100% !important;
		}
	}
`;
//# sourceMappingURL=Menu.style.js.map